import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["name"];
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseTime } from '@/utils';
import { getCustomerList, getCustomerInfo } from '@/views/cardSystem/customer/api/index';
import { createProjectDelivery, getProjectDeliveryDetail, launchedAgain, auditProjectDelivery, auditProjectTask, auditQuotationApproval, getProjectDeliveryHandleUser, getProjectManager, getProjectDeliveryLeader, getProjectPassDetail, submitProjectLater, getUserOpportunity, getBusinessType, getAddOrderCardType, editOtherSuppliers, editQuotationSheet, editBidLetter, editShopDecoration, editCustomDesign, editRequirementProject, editPersonalizedProject, bidOpeningDeliveryInformationEdit } from '../api';
import ApplyInfoPanel from './components/applyForm/ApplyInfoPanel.vue';
import ApplyLogPanel from './components/applyForm/ApplyLogPanel.vue';
import { createTaskItemDefaults, createOtherSupplierRow, createUnitedServiceSupplier, normalizeCustomerId, normalizeOtherSuppliers, normalizeBiddingSuppliers } from './components/applyForm/utils/taskData';
import { buildDisabledTaskPrefixes, findCustomerName, getProjectInfoStatus } from './components/applyForm/utils/form';

// 分块编辑策略表：快照/还原/校验前缀/保存接口与报文（替代 start/cancel/confirm 三段 if 链）
// prefixes 为该块参与保存校验的 rules 字段前缀；为空数组表示保存前无需校验
var EDIT_STRATEGY = {
  demand: {
    prefixes: ['project_name'],
    api: editRequirementProject,
    getSnapshot: function getSnapshot(vm) {
      return vm.formData.project_name;
    },
    restore: function restore(vm, snapshot) {
      vm.formData.project_name = snapshot;
    },
    buildPayload: function buildPayload(vm) {
      return {
        project_id: String(vm.id),
        project_name: String(vm.formData.project_name || '')
      };
    }
  },
  supplier: {
    prefixes: [],
    api: editOtherSuppliers,
    getSnapshot: function getSnapshot(vm) {
      return JSON.parse(JSON.stringify(vm.formData.project_meeting.other_suppliers || []));
    },
    restore: function restore(vm, snapshot) {
      vm.$set(vm.formData.project_meeting, 'other_suppliers', snapshot);
    },
    buildPayload: function buildPayload(vm) {
      return {
        project_id: String(vm.id),
        other_suppliers: normalizeOtherSuppliers(vm.formData.project_meeting.other_suppliers)
      };
    }
  },
  quotation: {
    prefixes: [],
    api: editQuotationSheet,
    getSnapshot: function getSnapshot(vm) {
      return vm.formData.project_meeting.quotation;
    },
    restore: function restore(vm, snapshot) {
      vm.formData.project_meeting.quotation = snapshot;
    },
    buildPayload: function buildPayload(vm) {
      return {
        project_id: String(vm.id),
        quotation: vm.formData.project_meeting.quotation || ''
      };
    }
  },
  projectInfo: {
    prefixes: ['project_evaluation.', 'project_meeting.', 'person_charge_id'],
    api: editPersonalizedProject,
    getSnapshot: function getSnapshot(vm) {
      return {
        project_evaluation: JSON.parse(JSON.stringify(vm.formData.project_evaluation || {})),
        project_meeting: JSON.parse(JSON.stringify(vm.formData.project_meeting || {})),
        type: JSON.parse(JSON.stringify(vm.formData.type || [])),
        person_charge_id: vm.formData.person_charge_id,
        person_charge_name: vm.formData.person_charge_name
      };
    },
    restore: function restore(vm, snapshot) {
      vm.$set(vm.formData, 'project_evaluation', snapshot.project_evaluation);
      vm.$set(vm.formData, 'project_meeting', snapshot.project_meeting);
      vm.formData.type = snapshot.type;
      vm.formData.person_charge_id = snapshot.person_charge_id;
      vm.formData.person_charge_name = snapshot.person_charge_name;
    },
    buildPayload: function buildPayload(vm) {
      return {
        project_id: String(vm.id),
        project_evaluation: vm.formData.project_evaluation || {},
        project_meeting: vm.formData.project_meeting ? _objectSpread(_objectSpread({}, vm.formData.project_meeting), {}, {
          other_suppliers: normalizeOtherSuppliers(vm.formData.project_meeting.other_suppliers)
        }) : {},
        type: vm.formData.type || [],
        person_charge_id: vm.formData.person_charge_id || '',
        person_charge_name: vm.formData.person_charge_name || ''
      };
    }
  },
  bidOpeningDelivery: {
    prefixes: ['items.bidding_support.task_status', 'items.bidding_support.reason', 'items.bidding_support.supplier', 'items.bidding_support.delivery_status'],
    api: bidOpeningDeliveryInformationEdit,
    getSnapshot: function getSnapshot(vm) {
      return JSON.parse(JSON.stringify(vm.formData.items.bidding_support || {}));
    },
    restore: function restore(vm, snapshot) {
      vm.$set(vm.formData.items, 'bidding_support', snapshot);
    },
    buildPayload: function buildPayload(vm) {
      var bidData = vm.formData.items.bidding_support || {};
      // 开标结果=已中标时，任务状态取交付结果（550未交付 600已交付）
      var taskStatus = Number(bidData.task_status) === 550 ? bidData.delivery_status || '550' : bidData.task_status;
      return {
        project_id: String(vm.formData.id || ''),
        task_status: String(taskStatus || ''),
        reason: String(bidData.reason || ''),
        supplier: normalizeBiddingSuppliers(bidData.supplier),
        announcement: bidData.announcement || [],
        bid_opening_remarks: String(bidData.bid_opening_remarks || ''),
        delivery_remarks: String(bidData.delivery_remarks || '')
      };
    }
  },
  1: {
    prefixes: ['items.mall_decoration.'],
    api: editShopDecoration,
    getSnapshot: function getSnapshot(vm) {
      return JSON.parse(JSON.stringify(vm.formData.items.mall_decoration || {}));
    },
    restore: function restore(vm, snapshot) {
      vm.$set(vm.formData.items, 'mall_decoration', snapshot);
    },
    buildPayload: function buildPayload(vm) {
      var mallData = vm.formData.items.mall_decoration || {};
      return {
        task_id: String(mallData.delivery_type_id || ''),
        scene: String(mallData.scene || ''),
        budget: String(mallData.budget || ''),
        banner: String(mallData.banner || ''),
        delivery_time: String(mallData.delivery_time || ''),
        mall_name: String(mallData.mall_name || ''),
        package_id: String(mallData.package_id || ''),
        // 商品是否有折扣/商城商品折扣 字段已注释（需求下线，如需恢复取消注释）
        // discount: String(mallData.discount || ''),
        // has_discount: String(mallData.has_discount || ''),
        remark: String(mallData.remark || ''),
        person_charge_id: String(mallData.person_charge_id || ''),
        person_charge_name: String(mallData.person_charge_name || ''),
        modules: mallData.modules || []
      };
    }
  },
  2: {
    // 仅校验投标信息自身字段，避免连带校验开标&交付区块字段
    prefixes: ['items.bidding_support.person_charge_id', 'items.bidding_support.status', 'items.bidding_support.bid_files', 'items.bidding_support.is_check', 'items.bidding_support.check_person_id'],
    api: editBidLetter,
    getSnapshot: function getSnapshot(vm) {
      return JSON.parse(JSON.stringify(vm.formData.items.bidding_support || {}));
    },
    restore: function restore(vm, snapshot) {
      vm.$set(vm.formData.items, 'bidding_support', snapshot);
    },
    buildPayload: function buildPayload(vm) {
      var bidData = vm.formData.items.bidding_support || {};
      return {
        project_id: String(vm.id),
        status: bidData.status || '',
        is_check: bidData.is_check || '',
        check_person_id: bidData.check_person_id || '',
        check_person_name: bidData.check_person_name || '',
        bid_files: bidData.bid_files || '',
        person_charge_id: bidData.person_charge_id || '',
        person_charge_name: bidData.person_charge_name || ''
      };
    }
  },
  3: {
    prefixes: ['items.card_and_coupon_design.'],
    api: editCustomDesign,
    getSnapshot: function getSnapshot(vm) {
      return JSON.parse(JSON.stringify(vm.formData.items.card_and_coupon_design || {}));
    },
    restore: function restore(vm, snapshot) {
      vm.$set(vm.formData.items, 'card_and_coupon_design', snapshot);
    },
    buildPayload: function buildPayload(vm) {
      var designData = vm.formData.items.card_and_coupon_design || {};
      return {
        task_id: String(designData.delivery_type_id || ''),
        order_business_type: String(designData.order_business_type || ''),
        card_type: String(designData.card_type || ''),
        order_gift_id_type: String(designData.order_gift_id_type || ''),
        order_number: String(designData.order_number || ''),
        gift_id: String(designData.gift_id || ''),
        estimated_amount: String(designData.estimated_amount || ''),
        design_product_type: String(designData.design_product_type || ''),
        add_magnetic_stripe: String(designData.add_magnetic_stripe || ''),
        card_size: String(designData.card_size || ''),
        card_size_custom: String(designData.card_size_custom || ''),
        coupon_size: String(designData.coupon_size || ''),
        coupon_size_custom: String(designData.coupon_size_custom || ''),
        gift_coupon_type: String(designData.gift_coupon_type || ''),
        gift_coupon_size: String(designData.gift_coupon_size || ''),
        gift_coupon_size_custom: String(designData.gift_coupon_size_custom || ''),
        gift_coupon_special_requirement: String(designData.gift_coupon_special_requirement || ''),
        need_card_coupon_sleeve: String(designData.need_card_coupon_sleeve || ''),
        card_coupon_sleeve_size: String(designData.card_coupon_sleeve_size || ''),
        card_coupon_sleeve_size_custom: String(designData.card_coupon_sleeve_size_custom || ''),
        expedited_not: String(designData.expedited_not || ''),
        need_printing: String(designData.need_printing || ''),
        printing_quantity: Number(designData.printing_quantity) || 0,
        urgent_printing: String(designData.urgent_printing || ''),
        design_complexity: Number(designData.design_complexity) || 0,
        customer_logo: designData.customer_logo || [],
        refer_style: designData.refer_style || [],
        design_draft: designData.design_draft || [],
        customer_demand: String(designData.customer_demand || ''),
        person_charge_id: String(designData.person_charge_id || ''),
        person_charge_name: String(designData.person_charge_name || '')
      };
    }
  }
};
export default {
  components: {
    ApplyInfoPanel: ApplyInfoPanel,
    ApplyLogPanel: ApplyLogPanel
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    },
    projectType: {
      type: [String, Number],
      default: null
    },
    projectStatus: {
      type: [String, Number],
      default: null
    },
    fromTab: {
      type: String,
      default: ''
    },
    selectedItemId: {
      type: [String, Number],
      default: null
    },
    rejectedTaskTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 嵌入审批抽屉时强制只读并始终展示日志 tab
    disableEdit: {
      type: Boolean,
      default: false
    },
    forceLogTab: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;
    return {
      activeTab: '1',
      companyList: [],
      opportunityList: [],
      userList: [],
      leaderOptions: [],
      decorationPersonList: [],
      cardDesignPersonList: [],
      bidSupportPersonList: [],
      approveDialogVisible: false,
      approveFormData: {
        audit: 1,
        group: null,
        person_charge_id: null,
        reason: '',
        groupName: '',
        groupIds: [],
        handleUser: null
      },
      otherUsers: [],
      groupUsers: [],
      approveRules: {
        group: [{
          required: true,
          message: '请选择是否拉群',
          trigger: 'change'
        }],
        groupName: [{
          required: true,
          message: '请输入群名称',
          trigger: 'blur'
        }],
        handleUser: [{
          required: true,
          message: '请选择项目负责人',
          trigger: 'change'
        }]
      },
      rejectDialogVisible: false,
      rejectFormData: {
        audit: 0,
        reason: ''
      },
      rejectRules: {
        reason: [{
          required: true,
          message: '请输入驳回原因',
          trigger: 'blur'
        }]
      },
      rules: {
        customer_id: [{
          required: true,
          message: '请选择客户',
          trigger: 'change'
        }],
        opportunity_id: [{
          required: true,
          message: '请选择商机',
          trigger: 'change'
        }],
        project_type: [{
          required: true,
          message: '请选择项目',
          trigger: 'change'
        }],
        project_name: [{
          required: true,
          message: '请输入需求名称',
          trigger: 'blur'
        }, {
          max: 50,
          message: '需求名称最多50个字符',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择需求类型',
          trigger: 'change'
        }],
        'items.mall_decoration.scene': [{
          required: true,
          message: '请选择使用场景',
          trigger: 'change'
        }],
        'items.mall_decoration.delivery_time': [{
          required: true,
          message: '请选择交付时间',
          trigger: 'change'
        }],
        'items.mall_decoration.budget': [{
          required: true,
          message: '请输入预算金额',
          trigger: ['blur', 'change']
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) return callback(new Error('请输入预算金额'));
            var v = String(value);
            var reg = /^\d{1,9}(?:\.\d{1,2})?$/;
            if (!reg.test(v)) {
              return callback(new Error('预算金额最多9位整数和2位小数'));
            }
            callback();
          },
          trigger: ['blur', 'change']
        }],
        'items.mall_decoration.mall_name': [{
          required: true,
          message: '请输入商城名称',
          trigger: ['blur', 'change']
        }],
        'items.mall_decoration.banner': [{
          required: true,
          message: '请选择客户Banner',
          trigger: 'change'
        }],
        'items.mall_decoration.modules': [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择至少一个功能板块',
          trigger: 'change'
        }],
        'items.mall_decoration.package_id': [{
          required: true,
          message: '请输入礼包方案ID',
          trigger: ['blur', 'change']
        }],
        // 商品是否有折扣/商城商品折扣 校验已注释（需求下线，如需恢复取消注释）
        // 'items.mall_decoration.has_discount': [
        // 	{
        // 		validator: (rule, value, callback) => {
        // 			if (this.formData.items.mall_decoration.modules.includes('4')) {
        // 				if (value === '' || value === null || value === undefined) {
        // 					return callback(new Error('请选择商品是否有折扣'))
        // 				}
        // 			}
        // 			callback()
        // 		},
        // 		trigger: 'change'
        // 	}
        // ],
        // 'items.mall_decoration.discount': [
        // 	{
        // 		validator: (rule, value, callback) => {
        // 			if (
        // 				this.formData.items.mall_decoration.modules.includes('4') &&
        // 				this.formData.items.mall_decoration.has_discount === '2'
        // 			) {
        // 				if (value === '' || value === null || value === undefined) {
        // 					return callback(new Error('请输入商城商品折扣'))
        // 				}
        // 			}
        // 			callback()
        // 		},
        // 		trigger: ['blur', 'change']
        // 	}
        // ],
        'items.mall_decoration.remark': [{
          required: true,
          message: '请输入装修描述',
          trigger: 'blur'
        }, {
          type: 'string',
          max: 500,
          message: '最多500个字符',
          trigger: 'blur'
        }],
        'items.mall_decoration.person_charge_id': [{
          required: true,
          message: '请选择装修负责人',
          trigger: 'change'
        }],
        'project_evaluation.project_basic_info': [{
          required: true,
          message: '请输入项目基本信息',
          trigger: 'blur'
        }],
        'project_evaluation.is_bidding': [{
          required: true,
          message: '请选择是否投标',
          trigger: 'change'
        }],
        'project_evaluation.need_bid_writing': [{
          required: true,
          message: '请选择是否需要写标书',
          trigger: 'change'
        }],
        'project_evaluation.registration_company_entity': [{
          required: true,
          message: '请输入报名公司主体',
          trigger: 'blur'
        }, {
          max: 50,
          message: '最多50个字符',
          trigger: 'blur'
        }],
        'project_evaluation.want_cooperate_bid_dept': [{
          required: true,
          message: '请选择是否希望和投标部合作',
          trigger: 'change'
        }],
        'project_evaluation.project_files': [{
          required: true,
          message: '请上传项目文件',
          trigger: 'change'
        }],
        'project_evaluation.purchase_content': [{
          required: true,
          message: '请选择采购内容',
          trigger: 'change'
        }],
        'project_meeting.bid_strategy_resources': [{
          required: true,
          message: '请输入应标策略资源',
          trigger: 'blur'
        }],
        'project_meeting.process_result': [{
          required: true,
          message: '请选择处理结果',
          trigger: 'change'
        }],
        person_charge_id: [{
          required: true,
          message: '请选择项目负责人',
          trigger: 'change'
        }],
        'project_meeting.customer_relationship': [{
          required: true,
          message: '请选择客情系数',
          trigger: 'change'
        }],
        'project_meeting.purchase_count': [{
          required: true,
          message: '请输入采购人数',
          trigger: 'blur'
        }],
        'project_meeting.per_capita_budget': [{
          required: true,
          message: '请输入单人预算',
          trigger: 'blur'
        }],
        'project_meeting.bid_opening_method': [{
          required: true,
          message: '请选择开标方式',
          trigger: 'change'
        }],
        'project_meeting.bid_send_time': [{
          required: true,
          message: '请选择标书寄出/上传时间',
          trigger: 'change'
        }],
        'project_meeting.bid_opening_time': [{
          required: true,
          message: '请选择开标/比选时间',
          trigger: 'change'
        }],
        'project_meeting.need_sample': [{
          required: true,
          message: '请选择是否需要样品',
          trigger: 'change'
        }],
        'project_meeting.sample_deadline': [{
          required: true,
          message: '请选择样品最晚寄出时间',
          trigger: 'change'
        }],
        'project_meeting.demo_type': [{
          required: true,
          message: '请选择是否演示',
          trigger: 'change'
        }],
        'project_meeting.quotation_type': [{
          required: true,
          message: '请选择报价形式',
          trigger: 'change'
        }],
        'project_meeting.settlement_method': [{
          required: true,
          message: '请选择结算方式',
          trigger: 'change'
        }],
        'project_meeting.report_type': [{
          required: true,
          message: '请选择是否汇报',
          trigger: 'change'
        }],
        'items.bidding_support.person_charge_id': [{
          required: true,
          message: '请选择投标负责人',
          trigger: 'change'
        }],
        'items.bidding_support.status': [{
          required: true,
          message: '请选择标书状态',
          trigger: 'change'
        }],
        'items.bidding_support.bid_files': [{
          required: true,
          message: '请上传投标文件',
          trigger: 'change'
        }],
        'items.bidding_support.is_check': [{
          required: true,
          message: '请选择是否检查',
          trigger: 'change'
        }],
        'items.bidding_support.check_person_id': [{
          required: true,
          message: '请选择检查人',
          trigger: 'change'
        }],
        'items.bidding_support.task_status': [{
          required: true,
          message: '请选择开标结果',
          trigger: 'change'
        }],
        'items.bidding_support.delivery_status': [{
          validator: function validator(rule, value, callback) {
            var bidding = _this.formData.items.bidding_support;
            if (Number(bidding.task_status) === 550 && !value) {
              callback(new Error('请选择交付结果'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }],
        'items.bidding_support.reason': [{
          required: true,
          message: '请选择优联未中标原因',
          trigger: 'change'
        }],
        'items.bidding_support.supplier': [{
          validator: function validator(rule, value, callback) {
            for (var i = 0; i < value.length; i++) {
              if (!value[i].company_name) {
                callback(new Error('请填写供应商名称'));
                return;
              }
              if (!value[i].price) {
                callback(new Error('请填写报价'));
                return;
              }
            }
            callback();
          },
          trigger: 'change'
        }],
        'items.card_and_coupon_design.order_business_type': [{
          required: true,
          message: '请选择订单业务类型',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.card_type': [{
          required: true,
          message: '请选择卡类型',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.order_gift_id_type': [{
          required: true,
          message: '请选择创建订单/礼包ID',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.design_product_type': [{
          required: true,
          message: '请选择设计产品类型',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.add_magnetic_stripe': [{
          required: true,
          message: '请选择卡增加磁条',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.card_size': [{
          required: true,
          message: '请选择卡尺寸',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.card_size_custom': [{
          message: '请输入特殊卡尺寸',
          trigger: 'blur'
        }],
        'items.card_and_coupon_design.coupon_size': [{
          required: true,
          message: '请选择券尺寸',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.coupon_size_custom': [{
          message: '请输入特殊券尺寸',
          trigger: 'blur'
        }],
        'items.card_and_coupon_design.gift_coupon_type': [{
          required: true,
          message: '请选择礼包券类型',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.gift_coupon_size': [{
          required: true,
          message: '请选择礼包券尺寸',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.gift_coupon_size_custom': [{
          message: '请输入特殊展开尺寸',
          trigger: 'blur'
        }],
        'items.card_and_coupon_design.gift_coupon_special_requirement': [{
          required: true,
          message: '请输入特殊要求',
          trigger: 'blur'
        }],
        'items.card_and_coupon_design.need_card_coupon_sleeve': [{
          required: true,
          message: '请选择是否需要卡券套',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.card_coupon_sleeve_size': [{
          required: true,
          message: '请选择卡券套尺寸',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.card_coupon_sleeve_size_custom': [{
          message: '请输入特殊卡券套尺寸',
          trigger: 'blur'
        }],
        'items.card_and_coupon_design.expedited_not': [{
          required: true,
          message: '请选择是否加急设计',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.need_printing': [{
          required: true,
          message: '请选择是否需要印刷',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.printing_quantity': [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (/^[1-9]\d*$/.test(String(value))) {
              callback();
              return;
            }
            callback(new Error('请输入大于0的正整数'));
          },
          trigger: 'blur'
        }],
        'items.card_and_coupon_design.urgent_printing': [{
          required: true,
          message: '请选择是否加急印刷',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.customer_logo': [{
          required: true,
          message: '请上传客户logo及其他图片',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.refer_style': [{
          required: true,
          type: 'array',
          min: 1,
          message: '请上传参考风格',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.customer_demand': [{
          required: true,
          message: '请输入客户需求描述',
          trigger: 'blur'
        }],
        'items.card_and_coupon_design.person_charge_id': [{
          required: true,
          message: '请选择设计负责人',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.design_draft': [{
          required: true,
          message: '请上传设计稿',
          trigger: 'change'
        }],
        'items.card_and_coupon_design.design_complexity': [{
          validator: function validator(rule, value, callback) {
            if ([1, 2, 3].includes(Number(value))) {
              callback();
              return;
            }
            callback(new Error('请选择设计复杂度'));
          },
          trigger: 'change'
        }],
        'items.quotation.business_type': [{
          required: true,
          message: '请选择业务类型',
          trigger: 'change'
        }],
        'items.quotation.card_type': [{
          required: true,
          message: '请选择卡类型',
          trigger: 'change'
        }],
        'items.quotation.money': [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (/^\d+(\.\d{1,2})?$/.test(String(value))) {
              callback();
              return;
            }
            callback(new Error('请输入大于等于0的数，最多两位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.number': [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (/^[1-9]\d*$/.test(String(value))) {
              callback();
              return;
            }
            callback(new Error('请输入大于0的正整数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.budget': [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (/^\d+(\.\d{1,2})?$/.test(String(value))) {
              callback();
              return;
            }
            callback(new Error('请输入大于等于0的数，最多两位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.payment_method': [{
          required: true,
          message: '请选择结算方式',
          trigger: 'change'
        }],
        'items.quotation.description': [{
          required: true,
          message: '请选择功能菜单描述',
          trigger: 'change'
        }],
        'items.quotation.final_quotation': [{
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) {
              callback();
              return;
            }
            var num = Number(value);
            if (/^(0|[1-9]\d*)(\.\d{1,3})?$/.test(String(value)) && num >= 0 && num <= 1) {
              callback();
              return;
            }
            callback(new Error('请输入0-1之间的数，最多三位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.cost': [{
          required: true,
          validator: function validator(rule, value, callback) {
            var num = Number(value);
            if (/^(0|[1-9]\d{0,7})(\.\d{1,2})?$/.test(String(value)) && num >= 0 && num < 100000000) {
              callback();
              return;
            }
            callback(new Error('请输入8位以内的数字，最多两位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.time_limit': [{
          required: true,
          message: '请选择报价单时效',
          trigger: 'change'
        }],
        'items.quotation.accounting_method': [{
          required: true,
          message: '请选择佣金核算方式',
          trigger: 'change'
        }],
        'items.quotation.commission': [{
          required: true,
          validator: function validator(rule, value, callback) {
            var num = Number(value);
            if (/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(String(value)) && num >= 0 && num <= 100) {
              callback();
              return;
            }
            callback(new Error('请输入0-100之间的数，最多两位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.performance': [{
          required: true,
          validator: function validator(rule, value, callback) {
            var num = Number(value);
            if (/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(String(value)) && num >= 0 && num <= 500) {
              callback();
              return;
            }
            callback(new Error('请输入0-500之间的数，最多两位小数'));
          },
          trigger: 'blur'
        }]
      },
      // mall_decoration 商城装修
      // bidding_support 招投标支持
      // card_and_coupon_design 卡券设计(印刷)
      // special_approval_sales_discounts 销售折扣特批
      // business_support 商务支持
      // union_implementation 智慧工会实施
      // card_rule_adjustments 卡规则调整(含商品打折)
      // trade_union_activities 工会活动
      formData: {
        customer_id: '',
        customer_nature: '',
        // 客户类型：-1未认定 1一类 3二类 2三类（报价单任务认定后由后端回填）
        create_name: '',
        organize_name: '',
        opportunity_id: '',
        customers_num: '',
        per_capita_budget: '',
        amount: '',
        project_type: '',
        // 项目类型：1-个性化项目评估(启动会) 2-其他个性化需求
        project_name: '',
        person_charge_id: '',
        person_charge_name: '',
        type: [],
        // 任务类型：1-商城装修
        items: createTaskItemDefaults(),
        project_evaluation: {
          project_basic_info: '',
          // 项目基本信息（投标时必填）
          is_bidding: '',
          // 是否投标：1-投标 2-非招投标
          need_bid_writing: '',
          // 是否需要写标书：1-否 2-是
          registration_company_entity: '',
          want_cooperate_bid_dept: '',
          // 是否希望和投标部合作：1-是 2-否
          project_files: [],
          purchase_content: [],
          // 采购内容：1-礼包 2-商城 3-线下商超 4-生日 5-电影 6-第三方功能
          is_deal_customer: '',
          // 是否成交客户：1-否 2-是
          history_competitor_info: '',
          history_discount_info: '',
          history_delivery_form: ''
        },
        project_meeting: {
          process_result: '',
          // 处理结果：1-项目立项通过 2-项目立项失败
          customer_relationship: '',
          // 客情系数：S/A/B/C/D
          purchase_count: undefined,
          per_capita_budget: undefined,
          purchase_amount: '',
          bid_opening_method: '',
          // 开标方式：1-电子开标 2-线下开标
          bid_send_time: '',
          bid_opening_time: '',
          need_sample: '',
          // 是否需要样品：1-否 2-是
          sample_deadline: '',
          demo_type: '',
          // 是否演示：1-无需演示 2-线上演示 3-线下演示
          quotation_type: '',
          // 报价形式：1-折扣率 2-上浮率 3-总价报价 4-单价报价 5-无需报价
          settlement_method: '',
          // 结算方式：1-发卡结算 2-消费据实结算
          report_type: '',
          // 是否汇报：1-无需汇报 2-线上PPT讲解 3-线下PPT讲解
          meeting_minutes: '',
          meeting_minutes_file: [],
          abandon_reason: '',
          bid_strategy_resources: '',
          history_order_director: '',
          quotation: '',
          other_suppliers: [createOtherSupplierRow()]
        }
      },
      cardTypeList: [],
      quotationCardTypeList: [],
      // 报价单审批人接口返回：status=1 表示审批人信息不完整，message 为提示文案
      leaderStatus: 0,
      leaderMessage: '',
      businessTypeList: [],
      quotationBusinessTypeList: [],
      initialTypes: [],
      editingTaskType: '',
      editTaskSnapshot: null,
      submitLoading: false,
      approveLoading: false,
      // 报价单审批走独立接口，单独做提交互斥，避免连点叠加二次确认弹窗
      editSaving: false
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var initRequests;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            initRequests = [_this2.getCompanyList(), _this2.getBusinessTypeList()];
            if (_this2.type === 'projectReview' || _this2.type === 'view') {
              initRequests.push(_this2.getLeaderOptions());
            }
            if (_this2.id) {
              initRequests.push(_this2.viewDetail());
            }
            _context.n = 1;
            return Promise.all(initRequests);
          case 1:
            if (!_this2.isCreateFlow) {
              _context.n = 2;
              break;
            }
            _context.n = 2;
            return _this2.getLeaderList();
          case 2:
            if (!_this2.id) {
              _this2.formData.create_name = _this2.$store.state.user.userInfo.nick_name;
            }
            _context.n = 3;
            return _this2.$store.dispatch('user/getSellUsers');
          case 3:
            _this2.bidSupportPersonList = (_this2.$store.state.user.sellUsersList || []).filter(function (item) {
              return item.status !== '0';
            });
            _this2.syncPersonChargeOptions();
            _this2.getDecorationPersonList();
            _this2.getCardDesignPersonList();
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    // 任务类型取消勾选时重置对应任务数据，避免隐藏区块的脏数据随表单提交
    'formData.type': function formDataType(newVal, oldVal) {
      var _this3 = this;
      var next = (newVal || []).map(String);
      var prev = (oldVal || []).map(String);
      prev.filter(function (taskType) {
        return !next.includes(taskType);
      }).forEach(function (taskType) {
        return _this3.resetTaskItem(taskType);
      });
      // 新勾选报价单时用商机数据预填金额/人数/单人预算
      if (next.includes('9') && !prev.includes('9')) {
        this.syncQuotationFromOpportunity();
      }
    }
  },
  computed: {
    inputName: function inputName() {
      return this.formData.create_name + (this.formData.organize_name ? '/' + this.formData.organize_name : '');
    },
    groupUserIds: function groupUserIds() {
      return this.groupUsers.map(function (item) {
        return item.id;
      });
    },
    // 创建流程：发起申请（含再次发起）与项目过会，只有这里需要校验发起人的审批人层级
    isCreateFlow: function isCreateFlow() {
      return ['add', 'projectReview'].includes(this.type);
    },
    // 报价单审批人是否异常（get-leader 返回 status=1：审批人信息不完整）
    quotationLeaderAbnormal: function quotationLeaderAbnormal() {
      return Number(this.leaderStatus) === 1;
    },
    quotationCheckboxDisabled: function quotationCheckboxDisabled() {
      return this.quotationLeaderAbnormal;
    },
    quotationCheckboxLabel: function quotationCheckboxLabel() {
      if (!this.quotationLeaderAbnormal) return '报价单';
      return "\u62A5\u4EF7\u5355\uFF08".concat(this.leaderMessage || '审批人信息不完整', "\uFF09");
    },
    showCardTypeField: function showCardTypeField() {
      var _this$formData$items, _this$formData$items$;
      var val = (_this$formData$items = this.formData.items) === null || _this$formData$items === void 0 ? void 0 : (_this$formData$items$ = _this$formData$items.card_and_coupon_design) === null || _this$formData$items$ === void 0 ? void 0 : _this$formData$items$.order_business_type;
      if (!val || !this.businessTypeList.length) return false;
      var item = this.businessTypeList.find(function (i) {
        return i.id == val;
      });
      if (!item) return false;
      return !['礼包', '优福卡', '优选卡'].includes(item.name);
    },
    isApproveOtherDemand: function isApproveOtherDemand() {
      return this.type === 'approve' && this.formData.project_type === '2';
    },
    isTaskApproval: function isTaskApproval() {
      return this.type === 'approve' && (this.formData.project_type === '2' || !!this.selectedItemId);
    },
    hadInitialDesignDraft: function hadInitialDesignDraft() {
      if (!this.isEditingTask('3') || !this.editTaskSnapshot) return false;
      var draft = this.editTaskSnapshot.design_draft || [];
      return Array.isArray(draft) && draft.length > 0;
    }
  },
  methods: {
    // 报价单时效默认值：审批当天 + 30 天
    getDefaultQuotationTimeLimit: function getDefaultQuotationTimeLimit() {
      var date = new Date();
      date.setDate(date.getDate() + 30);
      return parseTime(date, '{y}-{m}-{d}');
    },
    // 再次发起时任务区块是否禁用：初始已有的报价单仅在审批驳回(400)状态可编辑，
    // 追加的报价单任务（进入时未勾选）是新任务，可编辑提交，不受旧任务状态影响；
    // 其余任务看是否纳入本次再次发起
    isTaskFormDisabled: function isTaskFormDisabled(taskType) {
      if (this.type !== 'add' || !this.id) return false;
      if (String(taskType) === '9') {
        if (!this.initialTypes.includes('9')) return false;
        return String(this.formData.items.quotation.task_status) !== '400';
      }
      return this.formData.project_type == 2 && this.projectStatus != 1 && this.initialTypes.includes(String(taskType)) && !this.rejectedTaskTypes.includes(String(taskType));
    },
    isEditingTask: function isEditingTask(taskType) {
      return this.editingTaskType === String(taskType);
    },
    isViewTaskDisabled: function isViewTaskDisabled(taskType) {
      return this.type === 'view' && !this.isEditingTask(taskType);
    },
    taskItemKey: function taskItemKey(taskType) {
      return {
        1: 'mall_decoration',
        2: 'bidding_support',
        3: 'card_and_coupon_design',
        9: 'quotation'
      }[String(taskType)];
    },
    showProjectInfoEditButton: function showProjectInfoEditButton(taskType) {
      return !this.disableEdit && this.type === 'view' && this.$hasBtnRoles('/user/project-delivery/edit-project-information') && (!this.editingTaskType || this.isEditingTask(taskType)) && ![500, 600].includes(this.projectInfoStatus());
    },
    projectInfoStatus: function projectInfoStatus() {
      return getProjectInfoStatus(this.projectStatus, this.formData);
    },
    appendPersonChargeOption: function appendPersonChargeOption(options, person) {
      if (!(person !== null && person !== void 0 && person.person_charge_id) || !person.person_charge_name || options.some(function (item) {
        return String(item.id) === String(person.person_charge_id);
      })) {
        return;
      }
      options.push({
        id: person.person_charge_id,
        name: person.person_charge_name
      });
    },
    syncPersonChargeOptions: function syncPersonChargeOptions() {
      var items = this.formData.items || {};
      this.appendPersonChargeOption(this.leaderOptions, this.formData);
      this.appendPersonChargeOption(this.decorationPersonList, items.mall_decoration);
      this.appendPersonChargeOption(this.bidSupportPersonList, items.bidding_support);
      this.appendPersonChargeOption(this.cardDesignPersonList, items.card_and_coupon_design);
    },
    // 按前缀限定校验范围的表单校验，返回 Promise<boolean>
    // only：仅该前缀集合内字段的错误才拦截；except：排除该前缀集合字段后其余错误拦截
    // 仅依赖 el-form 公开的 validate/clearValidate，不再读取内部 form.fields
    validateFormScoped: function validateFormScoped(options) {
      if (!this.$refs.infoPanel) return Promise.resolve(false);
      return this.$refs.infoPanel.validateScoped(options);
    },
    focusTaskTabWithError: function focusTaskTabWithError() {
      if (this.$refs.infoPanel) this.$refs.infoPanel.focusTaskTabWithError();
    },
    // 再次发起模式下被禁用任务区块的字段前缀；这些字段用户不可编辑，提交校验需排除
    getDisabledTaskPrefixes: function getDisabledTaskPrefixes() {
      return buildDisabledTaskPrefixes(this.isTaskFormDisabled);
    },
    resetTaskItem: function resetTaskItem(taskType) {
      var key = this.taskItemKey(taskType);
      if (!key) return;
      this.$set(this.formData.items, key, createTaskItemDefaults()[key]);
    },
    getEditStrategy: function getEditStrategy(taskType) {
      return EDIT_STRATEGY[String(taskType)] || null;
    },
    startProjectInfoEdit: function startProjectInfoEdit(taskType) {
      var _this4 = this;
      var strategy = this.getEditStrategy(taskType);
      if (!strategy || this.editingTaskType) return;
      this.editingTaskType = String(taskType);
      this.editTaskSnapshot = strategy.getSnapshot(this);
      this.$nextTick(function () {
        return _this4.$refs.infoPanel && _this4.$refs.infoPanel.clearValidate();
      });
    },
    cancelProjectInfoEdit: function cancelProjectInfoEdit() {
      var _this5 = this;
      var strategy = this.getEditStrategy(this.editingTaskType);
      if (strategy && this.editTaskSnapshot !== null) {
        strategy.restore(this, this.editTaskSnapshot);
      }
      this.editingTaskType = '';
      this.editTaskSnapshot = null;
      this.$nextTick(function () {
        return _this5.$refs.infoPanel && _this5.$refs.infoPanel.clearValidate();
      });
    },
    confirmProjectInfoEdit: function confirmProjectInfoEdit() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var strategy, valid, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              strategy = _this6.getEditStrategy(_this6.editingTaskType);
              if (!(!strategy || _this6.editSaving)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (!strategy.prefixes.length) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return _this6.validateFormScoped({
                only: strategy.prefixes
              });
            case 2:
              valid = _context2.v;
              if (valid) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              _this6.editSaving = true;
              _context2.p = 4;
              _context2.n = 5;
              return strategy.api(strategy.buildPayload(_this6));
            case 5:
              _this6.$message.success('保存成功');
              _this6.editingTaskType = '';
              _this6.editTaskSnapshot = null;
              // 保存成功后回拉最新详情，避免抽屉打开期间本地数据与后端脱节
              _context2.n = 6;
              return _this6.viewDetail();
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t = _context2.v;
            case 8:
              _context2.p = 8;
              _this6.editSaving = false;
              return _context2.f(8);
            case 9:
              return _context2.a(2);
          }
        }, _callee2, null, [[4, 7, 8, 9]]);
      }))();
    },
    shouldShowTaskType: function shouldShowTaskType(taskType) {
      if (this.type === 'view' || !this.fromTab || this.fromTab == '1') return true;
      return this.fromTabTaskType() === String(taskType);
    },
    fromTabTaskType: function fromTabTaskType() {
      var tabToTypeMap = {
        2: '1',
        3: '2',
        4: '3',
        6: '9'
      };
      return tabToTypeMap[this.fromTab];
    },
    close: function close() {
      this.$emit('update:visible', false);
    },
    getCompanyList: function getCompanyList(val) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 1:
              res = _context3.v;
              _this7.companyList = res.data.list;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    changeCustomer: function changeCustomer(id) {
      var _this8 = this;
      this.formData.opportunity_id = '';
      this.formData.customers_num = '';
      this.formData.per_capita_budget = '';
      this.formData.amount = '';
      this.formData.project_evaluation.is_deal_customer = '';
      if (id) {
        this.getOpportunityInfo(id);
        this.getCustomerDealStatus(id);
      } else {
        this.opportunityList = [];
      }
      this.generateProjectName();
      this.$nextTick(function () {
        _this8.$refs.infoPanel && _this8.$refs.infoPanel.clearValidate('project_name');
      });
    },
    getCustomerDealStatus: function getCustomerDealStatus(id) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, dealStatusMap;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return getCustomerInfo({
                id: id,
                show_user_name: 0
              });
            case 1:
              res = _context4.v;
              dealStatusMap = {
                1: '1',
                2: '2',
                3: '2'
              };
              _this9.formData.project_evaluation.is_deal_customer = dealStatusMap[res.data.deal_status] || '1';
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getOpportunityInfo: function getOpportunityInfo(id) {
      var _this0 = this;
      getUserOpportunity({
        customer_id: id
      }).then(function (res) {
        _this0.opportunityList = res.data;
        if (_this0.formData.id) {
          // 详情回显/再次发起时报价单已有后端数据，只同步商机带出的项目字段，不重新预填
          _this0.changeOpportunity(_this0.formData.opportunity_id, false);
        }
      });
    },
    // prefillQuotation 为 false 时不回填报价单（详情回显/再次发起），避免覆盖已保存值
    changeOpportunity: function changeOpportunity(val) {
      var _this1 = this;
      var prefillQuotation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!val) {
        this.formData.customers_num = '';
        this.formData.per_capita_budget = '';
        this.formData.amount = '';
        if (prefillQuotation && this.formData.type.includes('9')) {
          this.formData.items.quotation.money = '';
          this.formData.items.quotation.number = '';
          this.formData.items.quotation.budget = '';
        }
        return;
      }
      this.opportunityList.forEach(function (el) {
        if (el.id === val) {
          _this1.formData.customers_num = el.info.customers_num;
          _this1.formData.per_capita_budget = el.info.per_capita_budget;
          _this1.formData.amount = el.info.amount;
        }
      });
      if (prefillQuotation) {
        this.syncQuotationFromOpportunity();
      }
    },
    // 勾选报价单或切换商机时，用商机数据预填采购金额/人数/单人预算（仍可手动修改）
    syncQuotationFromOpportunity: function syncQuotationFromOpportunity() {
      var _this10 = this;
      if (!this.formData.type.includes('9')) return;
      var opp = (this.opportunityList || []).find(function (el) {
        return el.id === _this10.formData.opportunity_id;
      });
      if (!opp || !opp.info) return;
      this.formData.items.quotation.money = opp.info.amount || '';
      this.formData.items.quotation.number = opp.info.customers_num || '';
      this.formData.items.quotation.budget = opp.info.per_capita_budget || '';
    },
    changeProject: function changeProject(val) {
      var _this11 = this;
      this.formData.type = [];
      this.generateProjectName();
      this.$nextTick(function () {
        _this11.$refs.infoPanel && _this11.$refs.infoPanel.clearValidate(['project_type', 'type', 'project_name']);
      });
    },
    generateProjectName: function generateProjectName() {
      if (!this.formData.project_type || !this.formData.customer_id) {
        this.formData.project_name = '';
        return;
      }
      var companyName = this.getCustomerName();
      var now = new Date();
      var dateStr = now.getMonth() + 1 + '.' + now.getDate();
      var projectLabel = this.formData.project_type === '1' ? '项目需求' : '其他个性化需求';
      this.formData.project_name = this.formData.project_type === '1' ? companyName + '-(' + projectLabel + ')' : companyName + '-(' + projectLabel + ')-' + dateStr;
    },
    getCustomerName: function getCustomerName() {
      return findCustomerName(this.companyList, this.formData.customer_id);
    },
    // 提交/审批前按后端契约转换字段：投标供应商拆分名称并转 is_win，成交供应商只保留新字段
    // 返回副本避免影响表单内回显
    buildSubmitFormData: function buildSubmitFormData() {
      var _next$items;
      var formData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formData;
      var next = _objectSpread(_objectSpread({}, formData), {}, {
        project_meeting: formData.project_meeting ? _objectSpread(_objectSpread({}, formData.project_meeting), {}, {
          other_suppliers: normalizeOtherSuppliers(formData.project_meeting.other_suppliers)
        }) : formData.project_meeting
      });
      var biddingSupport = (_next$items = next.items) === null || _next$items === void 0 ? void 0 : _next$items.bidding_support;
      if (!biddingSupport || !Array.isArray(biddingSupport.supplier)) {
        return next;
      }
      return _objectSpread(_objectSpread({}, next), {}, {
        items: _objectSpread(_objectSpread({}, next.items), {}, {
          bidding_support: _objectSpread(_objectSpread({}, biddingSupport), {}, {
            supplier: normalizeBiddingSuppliers(biddingSupport.supplier)
          })
        })
      });
    },
    submitForm: function submitForm() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var valid, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!_this12.submitLoading) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _context5.n = 2;
              return _this12.validateFormScoped({
                except: _this12.getDisabledTaskPrefixes()
              });
            case 2:
              valid = _context5.v;
              if (valid) {
                _context5.n = 3;
                break;
              }
              _this12.focusTaskTabWithError();
              return _context5.a(2);
            case 3:
              _this12.submitLoading = true;
              _context5.p = 4;
              if (!_this12.formData.id) {
                _context5.n = 6;
                break;
              }
              _context5.n = 5;
              return _this12.again();
            case 5:
              _context5.n = 7;
              break;
            case 6:
              _context5.n = 7;
              return _this12.add();
            case 7:
              _context5.n = 9;
              break;
            case 8:
              _context5.p = 8;
              _t2 = _context5.v;
              _this12.submitLoading = false;
            case 9:
              return _context5.a(2);
          }
        }, _callee5, null, [[4, 8]]);
      }))();
    },
    submitProjectReview: function submitProjectReview() {
      var _this13 = this;
      if (this.submitLoading) return;
      this.validateFormScoped().then(function (valid) {
        if (!valid) {
          _this13.focusTaskTabWithError();
          return;
        }
        _this13.$confirm('确认提交项目待过会信息？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
          var _t3;
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.p = _context6.n) {
              case 0:
                _this13.submitLoading = true;
                _context6.p = 1;
                _context6.n = 2;
                return _this13.projectReview();
              case 2:
                _context6.n = 4;
                break;
              case 3:
                _context6.p = 3;
                _t3 = _context6.v;
                _this13.submitLoading = false;
              case 4:
                return _context6.a(2);
            }
          }, _callee6, null, [[1, 3]]);
        }))).catch(function () {});
      });
    },
    projectReview: function projectReview() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return submitProjectLater(_this14.buildSubmitFormData());
            case 1:
              res = _context7.v;
              _this14.$message.success('提交成功');
              _this14.$emit('close');
              _this14.$emit('update:visible', false);
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    add: function add() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return createProjectDelivery(_this15.buildSubmitFormData());
            case 1:
              res = _context8.v;
              _this15.$message.success('提交成功');
              _this15.$emit('close');
              _this15.$emit('update:visible', false);
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    again: function again() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return launchedAgain(_this16.buildSubmitFormData());
            case 1:
              res = _context9.v;
              _this16.$message.success('提交成功');
              _this16.$emit('close');
              _this16.$emit('update:visible', false);
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    viewDetail: function viewDetail() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _formData$project_eva, _formData$items, _formData$items$card_;
        var obj, res, MALL_DECORATION_DEFAULTS, BIDDING_SUPPORT_DEFAULTS, CARD_AND_COUPON_DESIGN_DEFAULTS, formData, supplierList, announcementList, QUOTATION_DEFAULTS, quotationData, otherSuppliers, targetType, savedCardType, savedQuotationCardType, company, _t4;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              obj = {
                id: _this17.id,
                get_group: _this17.type == 'approve' ? 1 : 0
              };
              if (_this17.fromTab && _this17.fromTab !== '1') {
                obj.task_type = _this17.fromTabTaskType();
              }
              if (!(_this17.projectType == 1)) {
                _context0.n = 2;
                break;
              }
              _context0.n = 1;
              return getProjectPassDetail(obj);
            case 1:
              _t4 = _context0.v;
              _context0.n = 4;
              break;
            case 2:
              _context0.n = 3;
              return getProjectDeliveryDetail(obj);
            case 3:
              _t4 = _context0.v;
            case 4:
              res = _t4;
              MALL_DECORATION_DEFAULTS = {
                scene: '',
                delivery_time: '',
                budget: '',
                mall_name: '',
                banner: '',
                modules: [],
                package_id: '',
                // 商品是否有折扣/商城商品折扣 字段已注释（需求下线，如需恢复取消注释）
                // has_discount: '',
                // discount: '',
                remark: '',
                person_charge_id: '',
                person_charge_name: ''
              };
              BIDDING_SUPPORT_DEFAULTS = {
                person_charge_id: null,
                person_charge_name: '',
                status: '',
                bid_files: [],
                is_check: '',
                check_person_id: null,
                check_person_name: '',
                task_status: '',
                reason: '',
                supplier: [createUnitedServiceSupplier()],
                announcement: [],
                bid_opening_remarks: '',
                delivery_remarks: ''
              };
              CARD_AND_COUPON_DESIGN_DEFAULTS = {
                order_business_type: '',
                card_type: '',
                order_gift_id_type: '',
                order_number: '',
                gift_id: '',
                estimated_amount: '',
                design_product_type: '',
                add_magnetic_stripe: '',
                card_size: '',
                card_size_custom: '',
                coupon_size: '',
                coupon_size_custom: '',
                gift_coupon_type: '',
                gift_coupon_size: '',
                gift_coupon_size_custom: '',
                gift_coupon_special_requirement: '',
                need_card_coupon_sleeve: '',
                card_coupon_sleeve_size: '',
                card_coupon_sleeve_size_custom: '',
                expedited_not: '',
                need_printing: '',
                printing_quantity: '',
                urgent_printing: '',
                design_complexity: 0,
                customer_logo: [],
                refer_style: [],
                customer_demand: '',
                person_charge_id: '',
                person_charge_name: ''
              };
              formData = res.data;
              formData.person_charge_id = formData.person_charge_id || '';
              formData.person_charge_name = formData.person_charge_name || '';

              // 客户类型是项目级单选字段，接口可能返回数字/null，统一成空字符串或字符串保证回显
              formData.customer_nature = formData.customer_nature == null ? '' : String(formData.customer_nature);
              formData.items = formData.items || {};
              formData.items.mall_decoration = _objectSpread(_objectSpread({}, MALL_DECORATION_DEFAULTS), formData.items.mall_decoration);
              formData.items.bidding_support = _objectSpread(_objectSpread({}, BIDDING_SUPPORT_DEFAULTS), formData.items.bidding_support);
              // 开标结果与交付结果拆分：task_status 550/600 表示已中标后的交付状态
              // 统一转为字符串，保证与 el-radio label 严格匹配
              formData.items.bidding_support.task_status = String(formData.items.bidding_support.task_status || '');
              formData.items.bidding_support.delivery_status = String(formData.items.bidding_support.delivery_status || '');
              if (Number(formData.items.bidding_support.task_status) === 600) {
                formData.items.bidding_support.delivery_status = '600';
                formData.items.bidding_support.task_status = '550';
              } else if (Number(formData.items.bidding_support.task_status) === 550) {
                formData.items.bidding_support.delivery_status = '550';
              }
              // 供应商参标情况：name 拆分为 company_name/customer_id，is_win 字符串转布尔；
              // customer_id 非空的行补进下拉选项，旧数据未匹配时由模板提示
              supplierList = Array.isArray(formData.items.bidding_support.supplier) ? formData.items.bidding_support.supplier : [];
              formData.items.bidding_support.supplier = supplierList.map(function (item, index) {
                var companyName = item.company_name || item.name || (index === 0 ? '优联服务' : '');
                var customerId = normalizeCustomerId(item.customer_id) || (index === 0 ? '296' : '');
                return _objectSpread(_objectSpread({}, item), {}, {
                  company_name: companyName,
                  customer_id: customerId,
                  options: customerId ? [{
                    id: customerId,
                    company_name: companyName
                  }] : [],
                  is_win: String(item.is_win) === '1' || item.is_win === true
                });
              });
              if (!formData.items.bidding_support.supplier.length) {
                formData.items.bidding_support.supplier = [createUnitedServiceSupplier()];
              }
              // 中标公告：兼容接口返回数组或JSON字符串
              announcementList = formData.items.bidding_support.announcement;
              if (typeof announcementList === 'string' && announcementList) {
                try {
                  announcementList = JSON.parse(announcementList);
                } catch (_) {
                  announcementList = [];
                }
              }
              formData.items.bidding_support.announcement = Array.isArray(announcementList) ? announcementList : [];
              formData.items.card_and_coupon_design = _objectSpread(_objectSpread({}, CARD_AND_COUPON_DESIGN_DEFAULTS), formData.items.card_and_coupon_design);
              formData.items.card_and_coupon_design.refer_style = (formData.items.card_and_coupon_design.refer_style || []).map(function (_ref2) {
                var name = _ref2.name,
                  item = _objectWithoutProperties(_ref2, _excluded);
                return _objectSpread(_objectSpread({}, item), {}, {
                  file_name: item.file_name || name || ''
                });
              });
              formData.items.card_and_coupon_design.design_complexity = Number(formData.items.card_and_coupon_design.design_complexity) || 0;
              QUOTATION_DEFAULTS = createTaskItemDefaults().quotation;
              quotationData = _objectSpread(_objectSpread({}, QUOTATION_DEFAULTS), formData.items.quotation); // 后端可能返回 null 的标量字段，统一转为空字符串避免输入框显示 "null"
              Object.keys(quotationData).forEach(function (key) {
                if (quotationData[key] === null || quotationData[key] === undefined) {
                  quotationData[key] = '';
                }
              })
              // 下拉/单选字段统一转字符串，避免数字值与选项值不匹配导致回显失败
;
              ['accounting_method'].forEach(function (key) {
                if (quotationData[key] !== '') {
                  quotationData[key] = String(quotationData[key]);
                }
              });
              // 报价单时效默认取审批当天 + 30 天，后端已回填时以后端值为准
              if (_this17.type === 'approve' && !quotationData.time_limit) {
                quotationData.time_limit = _this17.getDefaultQuotationTimeLimit();
              }
              _this17.$set(formData.items, 'quotation', quotationData);
              if (formData.project_evaluation || _this17.type == 'projectReview') {
                formData.project_evaluation = _objectSpread({
                  project_basic_info: '',
                  is_bidding: '',
                  need_bid_writing: '',
                  want_cooperate_bid_dept: '',
                  project_files: [],
                  purchase_content: [],
                  is_deal_customer: '',
                  history_competitor_info: '',
                  history_discount_info: '',
                  history_delivery_form: ''
                }, formData.project_evaluation);
                formData.project_evaluation.project_files = formData.project_evaluation.project_files || [];
              }
              if (formData.project_meeting || _this17.type == 'projectReview') {
                formData.project_meeting = _objectSpread({
                  process_result: '',
                  customer_relationship: '',
                  purchase_count: undefined,
                  per_capita_budget: undefined,
                  purchase_amount: '',
                  bid_opening_method: '',
                  bid_send_time: '',
                  bid_opening_time: '',
                  need_sample: '',
                  sample_deadline: '',
                  demo_type: '',
                  quotation_type: '',
                  settlement_method: '',
                  report_type: '',
                  meeting_minutes: '',
                  meeting_minutes_file: [],
                  abandon_reason: '',
                  bid_strategy_resources: '',
                  history_order_director: '',
                  quotation: '',
                  other_suppliers: [createOtherSupplierRow()]
                }, formData.project_meeting);
                if (!Array.isArray(formData.project_meeting.meeting_minutes_file)) {
                  formData.project_meeting.meeting_minutes_file = [];
                }
                // 成交供应商拆分为 company_name/customer_id：旧数据仅回填旧名称，
                // 未匹配到 customer_id 时由模板提示；有 customer_id 的行补进下拉选项保证回显
                otherSuppliers = Array.isArray(formData.project_meeting.other_suppliers) ? formData.project_meeting.other_suppliers : [];
                formData.project_meeting.other_suppliers = otherSuppliers.map(function (item) {
                  var companyName = item.company_name || item.deal_supplier || '';
                  var customerId = normalizeCustomerId(item.customer_id);
                  return _objectSpread(_objectSpread({}, item), {}, {
                    company_name: companyName,
                    customer_id: customerId,
                    options: customerId ? [{
                      id: customerId,
                      company_name: companyName
                    }] : []
                  });
                });
              }
              _this17.formData = formData;
              _this17.syncPersonChargeOptions();

              // 启动会投标项目默认带投标支持任务，先补全再做来源任务收敛，否则 '2' 会漏进任务 tab
              if (_this17.projectType == 1 && ((_formData$project_eva = formData.project_evaluation) === null || _formData$project_eva === void 0 ? void 0 : _formData$project_eva.is_bidding) === '1') {
                if (!_this17.formData.type.includes('2')) {
                  _this17.formData.type.push('2');
                }
              }
              if (_this17.fromTab && _this17.type !== 'view') {
                targetType = _this17.fromTabTaskType();
                if (targetType) {
                  _this17.formData.type = (_this17.formData.type || []).map(String).filter(function (t) {
                    return t === targetType;
                  });
                }
              }

              // 保存卡类型值，避免 changeOrderBusinessType 清空
              savedCardType = (_formData$items = formData.items) === null || _formData$items === void 0 ? void 0 : (_formData$items$card_ = _formData$items.card_and_coupon_design) === null || _formData$items$card_ === void 0 ? void 0 : _formData$items$card_.card_type;
              _this17.changeOrderBusinessType();
              if (savedCardType) {
                _this17.$nextTick(function () {
                  _this17.formData.items.card_and_coupon_design.card_type = savedCardType;
                });
              }
              // 报价单：恢复卡类型选项与已选值
              if (_this17.formData.type.includes('9') && _this17.formData.items.quotation.business_type) {
                savedQuotationCardType = _this17.formData.items.quotation.card_type;
                _this17.changeQuotationBusinessType();
                if (savedQuotationCardType) {
                  _this17.$nextTick(function () {
                    _this17.formData.items.quotation.card_type = savedQuotationCardType;
                  });
                }
              }

              // 记录进入时已勾选的任务类型：再次发起时用于区分「已有任务」与「追加的新任务」
              if (_this17.type === 'add' && _this17.id) {
                _this17.initialTypes = _toConsumableArray(_this17.formData.type);
              }
              company = {
                id: res.data.customer_id,
                company_name: res.data.customer_name
              };
              if (!_this17.companyList.some(function (item) {
                return item.id === company.id;
              })) {
                _this17.companyList.push(company);
              }
              if (res.data.customer_id) {
                _this17.getOpportunityInfo(res.data.customer_id);
              }
            case 5:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    getDecorationPersonList: function getDecorationPersonList() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var res;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return getProjectDeliveryHandleUser({
                type: 3
              });
            case 1:
              res = _context1.v;
              _this18.decorationPersonList = res.data.list || [];
              _this18.syncPersonChargeOptions();
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    getCardDesignPersonList: function getCardDesignPersonList() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var res;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return getProjectDeliveryHandleUser({
                type: 5,
                item_name: '设计师'
              });
            case 1:
              res = _context10.v;
              _this19.cardDesignPersonList = res.data.list || [];
              _this19.syncPersonChargeOptions();
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    getLeaderOptions: function getLeaderOptions() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return getProjectManager();
            case 1:
              res = _context11.v;
              _this20.leaderOptions = res.data.list || [];
              _this20.syncPersonChargeOptions();
            case 2:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    // 报价单审批通过/驳回：二次确认后调用新接口（audit：1通过 2拒绝）
    confirmQuotationAudit: function confirmQuotationAudit(audit) {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var valid, confirmed, _t5;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              if (!_this21.approveLoading) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              _this21.approveLoading = true;
              _context12.p = 2;
              if (!(audit === 1)) {
                _context12.n = 4;
                break;
              }
              _context12.n = 3;
              return _this21.validateFormScoped({
                only: ['project_name', 'items.quotation.']
              });
            case 3:
              valid = _context12.v;
              if (valid) {
                _context12.n = 4;
                break;
              }
              _this21.focusTaskTabWithError();
              return _context12.a(2);
            case 4:
              _context12.n = 5;
              return _this21.$confirm(audit === 1 ? '确定审批通过？' : '确定审批驳回？', '提示', {
                confirmButtonText: '确 定',
                cancelButtonText: '取 消',
                type: 'warning'
              }).then(function () {
                return true;
              }).catch(function () {
                return false;
              });
            case 5:
              confirmed = _context12.v;
              if (confirmed) {
                _context12.n = 6;
                break;
              }
              return _context12.a(2);
            case 6:
              _context12.n = 7;
              return auditQuotationApproval({
                id: _this21.id,
                project_name: _this21.formData.project_name,
                quotation: _this21.formData.items.quotation,
                audit: audit
              });
            case 7:
              _this21.$message.success(audit === 1 ? '审批通过' : '审批驳回');
              _this21.$emit('close');
              _this21.$emit('update:visible', false);
              _context12.n = 9;
              break;
            case 8:
              _context12.p = 8;
              _t5 = _context12.v;
            case 9:
              _context12.p = 9;
              _this21.approveLoading = false;
              return _context12.f(9);
            case 10:
              return _context12.a(2);
          }
        }, _callee12, null, [[2, 8, 9, 10]]);
      }))();
    },
    handleApprove: function handleApprove() {
      var _this22 = this;
      // 报价单审批通过不再复用原审批弹窗逻辑，二次确认后调用新接口
      if (this.type === 'approve' && this.formData.type.includes('9')) {
        this.confirmQuotationAudit(1);
        return;
      }
      // approveLoading 覆盖校验、拉取审批人、提交三段，审批中忽略重复点击
      if (this.approveLoading) return;
      this.approveLoading = true;
      // 审批模式下客户/商机/项目/任务为审批人不可编辑字段，排除出校验，
      // 避免历史数据缺失时审批人被整表校验卡死
      var lockedProps = ['customer_id', 'opportunity_id', 'project_type', 'type'];
      this.validateFormScoped({
        except: lockedProps
      }).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(valid) {
          var _this22$formData$grou, _this22$formData$grou2, _this22$formData$item, _this22$formData$item2, _this22$formData$item3, _this22$formData$item4, _this22$formData$item5, _this22$formData$item6, fixedUsers, otherUsers, taskUsers, taskChargeMap;
          return _regenerator().w(function (_context13) {
            while (1) switch (_context13.n) {
              case 0:
                if (!valid) {
                  _context13.n = 2;
                  break;
                }
                _this22.approveFormData = {
                  audit: 1,
                  // 群已存在（chat_id 有值）时不再询问是否拉群，默认不拉群
                  group: _this22.formData.chat_id ? 0 : null,
                  person_charge_id: null,
                  reason: '',
                  groupName: '',
                  groupIds: [],
                  handleUser: null
                };
                _this22.otherUsers = [];
                _context13.n = 1;
                return _this22.getLeaderOptions();
              case 1:
                _this22.userList = _this22.$store.state.user.sellUsersList.filter(function (item) {
                  return item.status !== '0';
                });
                _this22.approveFormData.groupName = ((_this22$formData$grou = _this22.formData.group) === null || _this22$formData$grou === void 0 ? void 0 : _this22$formData$grou.title) || '';
                _this22.groupUsers = (((_this22$formData$grou2 = _this22.formData.group) === null || _this22$formData$grou2 === void 0 ? void 0 : _this22$formData$grou2.user_list) || []).map(function (item) {
                  return _objectSpread({
                    id: item.user_id,
                    name: item.nick_name
                  }, item);
                });
                // 任务审批时，将各任务负责人自动加入拟拉群名单且不可删除
                if (_this22.isTaskApproval) {
                  fixedUsers = _this22.groupUsers.filter(function (u) {
                    return u.disable === 1;
                  });
                  otherUsers = _this22.groupUsers.filter(function (u) {
                    return u.disable !== 1;
                  });
                  taskUsers = [];
                  taskChargeMap = {
                    1: {
                      personId: (_this22$formData$item = _this22.formData.items) === null || _this22$formData$item === void 0 ? void 0 : (_this22$formData$item2 = _this22$formData$item.mall_decoration) === null || _this22$formData$item2 === void 0 ? void 0 : _this22$formData$item2.person_charge_id,
                      list: _this22.decorationPersonList
                    },
                    2: {
                      personId: (_this22$formData$item3 = _this22.formData.items) === null || _this22$formData$item3 === void 0 ? void 0 : (_this22$formData$item4 = _this22$formData$item3.bidding_support) === null || _this22$formData$item4 === void 0 ? void 0 : _this22$formData$item4.person_charge_id,
                      list: _this22.bidSupportPersonList
                    },
                    3: {
                      personId: (_this22$formData$item5 = _this22.formData.items) === null || _this22$formData$item5 === void 0 ? void 0 : (_this22$formData$item6 = _this22$formData$item5.card_and_coupon_design) === null || _this22$formData$item6 === void 0 ? void 0 : _this22$formData$item6.person_charge_id,
                      list: _this22.cardDesignPersonList
                    }
                  };
                  (_this22.formData.type || []).forEach(function (taskType) {
                    var mapping = taskChargeMap[taskType];
                    if (mapping && mapping.personId) {
                      var person = mapping.list.find(function (p) {
                        return String(p.id) === String(mapping.personId);
                      });
                      if (person && !_this22.groupUsers.some(function (u) {
                        return u.id === person.id;
                      })) {
                        taskUsers.push(_objectSpread(_objectSpread({}, person), {}, {
                          disable: 1
                        }));
                      }
                    }
                  });
                  _this22.groupUsers = [].concat(_toConsumableArray(fixedUsers), taskUsers, _toConsumableArray(otherUsers));
                }
                _this22.leaderOptions = _this22.leaderOptions.map(function (item) {
                  return _objectSpread({
                    disable: 0
                  }, item);
                });
                _this22.userList = _this22.userList.map(function (item) {
                  return _objectSpread({
                    disable: 0
                  }, item);
                });
                _this22.approveDialogVisible = true;
                _this22.$nextTick(function () {
                  _this22.$refs.approveForm.clearValidate();
                });
              case 2:
                return _context13.a(2);
            }
          }, _callee13);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()).finally(function () {
        _this22.approveLoading = false;
      });
    },
    handleGroupUserClose: function handleGroupUserClose(item) {
      this.groupUsers = this.groupUsers.filter(function (user) {
        return user.id !== item.id;
      });
    },
    handleOtherUserClose: function handleOtherUserClose(item) {
      this.otherUsers = this.otherUsers.filter(function (user) {
        return user.id !== item.id;
      });
    },
    confirmApprove: function confirmApprove() {
      var _this23 = this;
      this.$refs.approveForm.validate(function (valid) {
        if (valid) {
          _this23.approve(1);
        }
      });
    },
    handleReject: function handleReject() {
      var _this24 = this;
      // 报价单审批驳回同样走新接口，二次确认后调用
      if (this.type === 'approve' && this.formData.type.includes('9')) {
        this.confirmQuotationAudit(2);
        return;
      }
      this.rejectDialogVisible = true;
      this.$nextTick(function () {
        _this24.$refs.rejectForm.clearValidate();
      });
    },
    confirmReject: function confirmReject() {
      var _this25 = this;
      this.$refs.rejectForm.validate(function (valid) {
        if (valid) {
          _this25.approve(0);
        }
      });
    },
    approve: function approve(status) {
      var _this26 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var data, _data$handleUser, _data$handleUser2, _data$handleUser3, _this26$approveFormDa, submitApi, res, _t6;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              if (!_this26.approveLoading) {
                _context14.n = 1;
                break;
              }
              return _context14.a(2);
            case 1:
              _this26.approveLoading = true;
              _context14.p = 2;
              data = {};
              if (status == 1) {
                data = _objectSpread(_objectSpread({}, _this26.formData), _this26.approveFormData);
                data.person_charge_id = (_data$handleUser = data.handleUser) === null || _data$handleUser === void 0 ? void 0 : _data$handleUser.id;
                data.person_charge_name = ((_data$handleUser2 = data.handleUser) === null || _data$handleUser2 === void 0 ? void 0 : _data$handleUser2.name) || '';
                data.handleName = ((_data$handleUser3 = data.handleUser) === null || _data$handleUser3 === void 0 ? void 0 : _data$handleUser3.name) || '';
                data.groupIds = [].concat(_toConsumableArray(_this26.groupUsers.map(function (item) {
                  return item.id;
                })), [(_this26$approveFormDa = _this26.approveFormData.handleUser) === null || _this26$approveFormDa === void 0 ? void 0 : _this26$approveFormDa.id], _toConsumableArray(_this26.otherUsers.map(function (item) {
                  return item.id;
                }))).filter(Boolean);
              } else {
                data = _objectSpread(_objectSpread({}, _this26.formData), _this26.rejectFormData);
              }
              submitApi = _this26.isTaskApproval ? auditProjectTask : auditProjectDelivery;
              if (submitApi === auditProjectTask && _this26.selectedItemId) {
                data.item_id = _this26.selectedItemId;
              }
              _context14.n = 3;
              return submitApi(_this26.buildSubmitFormData(data));
            case 3:
              res = _context14.v;
              _this26.$message.success(status == 1 ? '审批通过' : '审批驳回');
              _this26.approveDialogVisible = false;
              _this26.rejectDialogVisible = false;
              _this26.$emit('close');
              _this26.$emit('update:visible', false);
              _context14.n = 5;
              break;
            case 4:
              _context14.p = 4;
              _t6 = _context14.v;
            case 5:
              _context14.p = 5;
              _this26.approveLoading = false;
              return _context14.f(5);
            case 6:
              return _context14.a(2);
          }
        }, _callee14, null, [[2, 4, 5, 6]]);
      }))();
    },
    getBusinessTypeList: function getBusinessTypeList() {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var _yield$Promise$all, _yield$Promise$all2, normalRes, quotationRes;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _context15.n = 1;
              return Promise.all([getBusinessType(), getBusinessType({
                source: 9
              })]);
            case 1:
              _yield$Promise$all = _context15.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              normalRes = _yield$Promise$all2[0];
              quotationRes = _yield$Promise$all2[1];
              _this27.businessTypeList = normalRes.data || [];
              _this27.quotationBusinessTypeList = quotationRes.data || [];
            case 2:
              return _context15.a(2);
          }
        }, _callee15);
      }))();
    },
    // 报价单审批人：决定报价单勾选项是否可选及提示文案
    getLeaderList: function getLeaderList() {
      var _this28 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        var data, _t7, _t8;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              _context16.p = 0;
              _context16.n = 1;
              return getProjectDeliveryLeader();
            case 1:
              _t7 = _context16.v.data;
              if (_t7) {
                _context16.n = 2;
                break;
              }
              _t7 = {};
            case 2:
              data = _t7;
              _this28.leaderStatus = Number(data.status) || 0;
              _this28.leaderMessage = data.message || '';
              _context16.n = 4;
              break;
            case 3:
              _context16.p = 3;
              _t8 = _context16.v;
              _this28.leaderStatus = 1;
              _this28.leaderMessage = '';
            case 4:
              // 审批人不齐时若报价单已被勾选，自动取消（watcher 联动重置表单数据）
              if (_this28.quotationCheckboxDisabled && _this28.formData.type.includes('9')) {
                _this28.formData.type = _this28.formData.type.filter(function (t) {
                  return t !== '9';
                });
              }
            case 5:
              return _context16.a(2);
          }
        }, _callee16, null, [[0, 3]]);
      }))();
    },
    changeOrderBusinessType: function changeOrderBusinessType() {
      var _this29 = this;
      var val = this.formData.items.card_and_coupon_design.order_business_type;
      this.formData.items.card_and_coupon_design.card_type = '';
      if (!val) {
        this.cardTypeList = [];
        return;
      }
      getAddOrderCardType({
        business_id: val
      }).then(function (res) {
        _this29.cardTypeList = res.data || [];
      });
    },
    // 报价单：切换业务类型后重置卡类型并拉取对应卡类型选项（与卡券设计列表隔离，避免互相覆盖）
    changeQuotationBusinessType: function changeQuotationBusinessType() {
      var _this30 = this;
      var val = this.formData.items.quotation.business_type;
      this.formData.items.quotation.card_type = '';
      if (!val) {
        this.quotationCardTypeList = [];
        return;
      }
      getAddOrderCardType({
        business_id: val
      }).then(function (res) {
        _this30.quotationCardTypeList = res.data || [];
      });
    }
  }
};